import React, {useState} from 'react';
import type {WithRouterProps} from 'react-router';

import {BadgesAchieved} from './BadgesAchieved';
import type { FilterOption} from './types';
import {FILTER_OPTION} from './types';
import {FilterDropdown} from './FilterDropdown';
import {SkillPathList} from './SkillPathList';
import {useStudentSkillPath} from './hooks/useStudentSkillPath';

export function SkillPath({params}: WithRouterProps) {
  const classroomId: string | undefined = params?.classroomId;
  const [selectedFilter, setSelectedFilter] = useState<FilterOption>(FILTER_OPTION.TO_DO);

  const {skillSubjectGroups, diagnostics, badgeCounts, isLoading} = useStudentSkillPath(
    classroomId,
    selectedFilter
  );

  return (
    <div className='student-skill-path flex w-full flex-col'>
      <div className='flex items-center justify-between px-x2 py-x3 m:px-x4'>
        <FilterDropdown selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} />
        <BadgesAchieved badgeCounts={badgeCounts} />
      </div>
      <SkillPathList
        skillSubjectGroups={skillSubjectGroups}
        diagnostics={diagnostics}
        isLoading={isLoading}
      />
    </div>
  );
}
